const themeBlue = '#3c91e4';
const themeBlueLight = '#7cb5ed';
const themeBlueDark = '#196cbc';

const themeRed = '#f40028';
const themeRedDark = '#db0023';

const themePink = '#e760a5';

const colorAccent = themeBlue;
const colorAccentLight = themeBlueLight;
const colorAccentDark = themeBlueDark;
const colorPrimary = themeRed;
const colorPrimaryDark = themeRedDark;

export {colorPrimary, colorPrimaryDark, colorAccent, colorAccentLight, colorAccentDark};
